/// Catégorie de prompt
export enum PromptCategory {
  WRITING = 'WRITING', // Rédaction & contenu
  CODING = 'CODING', // Développement & code
  MARKETING = 'MARKETING', // Marketing & growth
  PRODUCTIVITY = 'PRODUCTIVITY', // Productivité & organisation
  ANALYSIS = 'ANALYSIS', // Analyse & audit
  CREATIVE = 'CREATIVE', // Créativité & design
  BUSINESS = 'BUSINESS', // Business model, stratégie & offre
  EDUCATION = 'EDUCATION', // Éducation & formation
  ADMIN_LEGAL = 'ADMIN_LEGAL', // Administratif, juridique pratique & démarches
  REAL_ESTATE = 'REAL_ESTATE', // Immobilier, habitat & urbanisme
  CONSTRUCTION = 'CONSTRUCTION', // Bâtiment, travaux & rénovation
  EXECUTIVE_ASSISTANT = 'EXECUTIVE_ASSISTANT', // Assistant de direction & entrepreneur
  FINANCE_ACCOUNTING = 'FINANCE_ACCOUNTING', // Finance, compta & pilotage
  HR_CAREER = 'HR_CAREER', // RH, carrière & management
  SALES = 'SALES', // Vente, relance & négociation
  CUSTOMER_SUPPORT = 'CUSTOMER_SUPPORT', // Support & relation client
  OPERATIONS = 'OPERATIONS', // Ops, process & back-office
  PERSONAL_LIFE = 'PERSONAL_LIFE', // Vie pratique & organisation personnelle
  CUSTOM = 'CUSTOM', // Autre / meta-prompts
}

/// Modèle IA cible
export enum AIModel {
  GPT4 = 'GPT4',
  CLAUDE = 'CLAUDE',
  GEMINI = 'GEMINI',
  MISTRAL = 'MISTRAL',
  UNIVERSAL = 'UNIVERSAL', // Fonctionne avec tous
}

/// Type de variable dans un prompt
export enum PromptVariableType {
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  SELECT = 'SELECT', // Choix parmi options
  TEXTAREA = 'TEXTAREA', // Texte long
}
